@if(!orderId && !orderNumber){
  <ng-container>
    <bt-loader [loaderId]="loaderId">
      @if(orders.data){
        <ng-container>
          <div class="flex margin-bottom">
            <div class="flex-1 flex center">
              <h4 class="margin-left-small">Order List</h4>
            </div>
            <div class="flex-0 nowrap">
              <button class="margin-right-small"
                      (click)="onOpenFilter()">
                <i class="fa fa-filter"></i>Open Filter
              </button>
            </div>
          </div>
    
          @for(s of statusFilters.selectedCached; track s){
            <span class="chip margin-x-small">
              {{s.orderStatusName}}
              <i class="fa fa-times margin-left-small"
                 (click)="removeStatusFilter(s)"></i>
            </span>
          }
    
          @if(datesFilters.fromDateCached){
            <span class="chip margin-x-small">
              Due date from {{datesFilters.fromDateCached | date: 'd MMM y'}}
              <i class="fa fa-times margin-left-small"
                 (click)="removeFromDateFilter()"></i>
            </span>
          }
          @if(datesFilters.toDateCached){
            <span class="chip margin-x-small">
              Due date to {{datesFilters.toDateCached | date: 'd MMM y'}}
              <i class="fa fa-times margin-left-small"
                 (click)="removeToDateFilter()"></i>
            </span>
          }
          @if(datesFilters.notSetDueDate){
            <span class="chip margin-x-small">
              Orders without due date
              <i class="fa fa-times margin-left-small"
                 (click)="removeWithoutDueDateFilter()"></i>
            </span>
          }
    
          <div class="card margin-top">
            @if(orders.data?.length){
              <ng-container>
                @if(gridColumns){
                  <table class="margin-bottom-small">
                    <tr>
                      @for(col of gridColumns; track col){
                        <th [ngStyle]="{'width': col.width ? (col.width + 'px') : null}">{{col.title}}</th>
                      }
                    </tr>
                    @for(item of orders.data; track item){
                      <tr>
                        @for(col of gridColumns; track col){
                          <td>
                            @if(!col.type || col.type === gridColumnTypeEnum.default){
                              <ng-container>
                                {{item[col.field]}}
                              </ng-container>
                            }
                            @if(col.type === gridColumnTypeEnum.date){
                              <ng-container>
                                {{item[col.field] ? (item[col.field] | date: 'd MMM y') : ' - not set - '}}
                              </ng-container>
                            }
                            @if(col.type === gridColumnTypeEnum.custom){
                              <ng-container>
                                {{item.approvedShots}} approved of {{item.totalShots}} shots
                              </ng-container>
                            }
                            @if(col.type === gridColumnTypeEnum.icon){
                              <ng-container>
                                <div class="pointer flex center justify-center">
                                  <bt-menu [show]="item.showMenu"
                                           (hidden)="item.showMenu = false"
                                           (showed)="item.showMenu = true">
                                    <div class="menu-item"
                                         (click)="onInfo(item)">
                                      <i class="fa fa-info"></i>Order info
                                    </div>
                                  </bt-menu>
                                </div>
                              </ng-container>
                            }
                          </td>
                        }
                      </tr>
                    }
                  </table>
                }
                <bt-paginator [pageNumber]="orders.page"
                              [pageSize]="orders.size"
                              [totalNumber]="orders.total"
                              (clickPage)="getOrders($event)"></bt-paginator>
              </ng-container>
            }
            @if(orders.data && !orders.data.length && !orders.page){
              <div class="no-data">
                <i class="fa fa-frown-o"></i>
                <div>There are no orders to view</div>
              </div>
            }
          </div>
        </ng-container>
      }
    </bt-loader>
  
    @if(currentSidebar === sidebarTypeEnum.filters){
      <bt-sidebar sidebarTitle="Filters"
                  (exit)="onExitFilters()">
        <div class="full-height flex">
          <div class="flex-1 overflow margin-bottom margin-top padding-left-x-small padding-right-x-small">
            <details class="details-filter-item"
                     [open]="false">
              <summary class="hover">
                <div class="flex center">
                  <div class="flex-1">
                    <h4>Order Status</h4>
                  </div>
                  <div class="summary-detail">
                    {{statusFilters.selectedCurrent.length}} applied
                  </div>
                  <div class="arrows">
                    <i class="fa fa-chevron-down"></i>
                    <i class="fa fa-chevron-up"></i>
                  </div>
                </div>
              </summary>
              <bt-loader [loaderId]="statusFilters.loaderId">
                <div class="margin-top-small overflow-container">
                  @for(s of statusFilters.data; track s){
                    <div class="padding-top-small padding-bottom-small flex center">
                      <input type="checkbox"
                             [(ngModel)]="s.checked"
                             (ngModelChange)="changeStatusCheckboxValue(s)">
                      <label class="padding-left-small pointer"
                             (click)="clickStatusLabel(s)">{{s.orderStatusName}}</label>
                    </div>
                  }
                </div>
              </bt-loader>
            </details>
            <details class="details-filter-item"
                     [open]="false">
              <summary class="hover">
                <div class="flex center">
                  <div class="flex-1">
                    <h4>Due date</h4>
                  </div>
                  <div class="summary-detail">
                    {{((datesFilters.fromDateCurrent || datesFilters.toDateCurrent) && !datesFilters.notSetDueDateCurrent)
                    || datesFilters.notSetDueDateCurrent ? 'set' : 'not set'}}
                  </div>
                  <div class="arrows">
                    <i class="fa fa-chevron-down"></i>
                    <i class="fa fa-chevron-up"></i>
                  </div>
                </div>
              </summary>
              <div class="margin-top">
                <div class="margin-bottom-small">
                  <input type="checkbox"
                         [(ngModel)]="datesFilters.notSetDueDateCurrent">
                  <label class="padding-left-small pointer"
                         (click)="datesFilters.notSetDueDateCurrent = !datesFilters.notSetDueDateCurrent">
                    Orders without due date
                  </label>
                </div>
                <div class="flex">
                  <div class="flex-1 margin-right-small">
                    <div class="margin-bottom-small flex center justify-between">
                      <span>From</span>
                      @if(!!datesFilters.fromDateCurrent){
                        <span class="hover pointer"
                              (click)="datesFilters.fromDateCurrent = null">(clear)</span>
                      }
                    </div>
                    <input type="date"
                           class="full-width"
                           [max]="datesFilters.toDateCurrent"
                           [disabled]="datesFilters.notSetDueDateCurrent"
                           [(ngModel)]="datesFilters.fromDateCurrent">
                  </div>
                  <div class="flex-1 margin-left-small">
                    <div class="margin-bottom-small flex center justify-between">
                      <span>To</span>
                      @if(!!datesFilters.toDateCurrent){
                        <span class="hover pointer"
                              (click)="datesFilters.toDateCurrent = null">(clear)</span>
                      }
                    </div>
                    <input type="date"
                           class="full-width"
                           [min]="datesFilters.fromDateCurrent"
                           [disabled]="datesFilters.notSetDueDateCurrent"
                           [(ngModel)]="datesFilters.toDateCurrent">
                  </div>
                </div>
              </div>
            </details>
          </div>
          <div class="flex-0">
            <button class="full-width"
                    (click)="applyFilters()">
              <i class="fa fa-check-circle-o"></i>Apply filters
            </button>
          </div>
        </div>
      </bt-sidebar>
    }
  </ng-container>
}

@if(orderId && orderNumber){

  <bt-photographer-order-info-auto-sorting [orderId]="orderId"
                              [orderNumber]="orderNumber"
                              [modelId]="modelId"
                              (exit)="onExitFromInfo()"></bt-photographer-order-info-auto-sorting>

  <!-- <bt-photographer-order-info [orderId]="orderId"
                              [orderNumber]="orderNumber"
                              [modelId]="modelId"
                              (exit)="onExitFromInfo()"></bt-photographer-order-info> -->
}
